import React from 'react';
import emailjs from 'emailjs-com';
import LatestBlog from './LatestBlog';
import Newsletter from './NewsLetter';
import GetInTouch from './GetInTouch';

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_id', 'template_id', e.target, 'user_id')
    .then((result) => {
      alert("Message Sent!");
    }, (error) => {
      alert("Failed to send message");
    });

  e.target.reset();
};


const Contact = () => {
  return (
    <>
      {/* Contact Header */}
      <div id='contactUs' style={{ backgroundColor: '#4cc9f0', padding: '50px 0', scrollMarginTop:'45px' }}>
        <h2 className="text-white text-center fw-bold mb-2">TO GET A QUOTE PLEASE CONTACT US</h2>
        <div className="d-flex justify-content-center">
          <div style={{ width: '80px', height: '4px', backgroundColor: 'white', borderRadius: '2px' }}></div>
        </div>

          <a
  href="https://wa.me/+919871115060"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold rounded-pill mt-4" 
  data-bs-toggle="tooltip"
  data-bs-placement="top"
  data-bs-title="Chat with us on WhatsApp"
  style={{ fontSize: '1.1rem' }}
>
  <i className="fab fa-whatsapp fa-lg"></i>
  Contact Us
</a>
      </div>
        <LatestBlog/>
        {/* <Newsletter/> */}

    {/* <GetInTouch/> */}
    </>
  );
};

export default Contact;
